import axios, { AxiosError } from 'axios'
import { API_STORAGE_URL } from 'constants/apiUrl'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { refreshAccessToken, requestInterceptorCallback } from 'services/axios/publicInstance'

const storageInstance = axios.create({ baseURL: API_STORAGE_URL })

// eslint-disable-next-line
const requestStorageInterceptor = storageInstance.interceptors.request.use(requestInterceptorCallback, function (error: AxiosError) {
  return Promise.reject(error)
})

createAuthRefreshInterceptor(storageInstance, refreshAccessToken, {})

export { storageInstance }
